import Vue from "vue";
import { mapState } from "vuex";
import type { IStoreState } from "@/store";
import { CompanyMembershipTypeEnum } from "@/apis/model/CompanyMembershipTypeEnum";
import { CompanyMemberTypeEnum } from "@/apis/model/CompanyMemberTypeEnum";
import { MyBasicAccountInfoViewModel } from "@/apis/model/MyBasicAccountInfoViewModel";
import { MyCompanyProfileViewModel } from "@/apis/model/MyCompanyProfileViewModel";
import { MyProfileViewModel } from "@/apis/model/MyProfileViewModel";

const TOKEN = "_token_";
const ME = "_me_";
const MY_PROFILE = "_myProfile_";
const MY_COMPANY = "_myCompany_";
// see https://forum.vuejs.org/t/using-mixins-with-typescript/24256/6
const AccountInfoMixin = Vue.extend({
  computed: {
    ...mapState({
      [TOKEN]: (state: IStoreState) => state.token,
      [ME]: (state: IStoreState) => state.me,
      [MY_PROFILE]: (state: IStoreState) => state.myProfile,
      [MY_COMPANY]: (state: IStoreState) => state.myCompany,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any),
    token(): string | undefined {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (this as any)[TOKEN] as string | undefined;
    },
    me(): MyBasicAccountInfoViewModel {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (this as any)[ME] as MyBasicAccountInfoViewModel;
    },
    myProfile(): MyProfileViewModel {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (this as any)[MY_PROFILE] as MyProfileViewModel;
    },
    myCompany(): MyCompanyProfileViewModel {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (this as any)[MY_COMPANY] as MyCompanyProfileViewModel;
    },
    companyMemberType(): CompanyMemberTypeEnum | undefined | null {
      return this.me?.CompanyMemberType;
    },
    isCompanyAdmin(): boolean {
      if (!this.companyMemberType) return false;
      return this.companyMemberType !== CompanyMemberTypeEnum.Member;
    },
    isVip(): boolean {
      return this.myCompany?.CompanyPackageType !== CompanyMembershipTypeEnum.None;
    },
  },
});

export default AccountInfoMixin;
